import React, { useEffect, useState } from 'react';
import '../../Assets/css/popUpMessage.css';
import { MdKeyboardArrowDown } from 'react-icons/md';

const PopUpMessage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setShowPopup(true);
    }, 1000);

    const timer2 = setTimeout(() => {
      setIsExpanded(false);
    }, 5000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <>
      {showPopup && (
        <div
          style={{
            position: 'absolute',
            bottom: '10px',
            left: '10px',
            right: '10px',
          }}
        >
          <div className="popup-container popup-slide-in" style={{ width: '34rem' }}>
            <div className="popup" style={{ position: 'relative' }}>
              <div role="button" tabIndex={0} className="dummyDivSelection" aria-label="Expand section" onClick={toggleExpand} />
              <div style={{ width: '100%' }}>
                <p
                  style={{
                    marginBottom: !isExpanded ? '0px' : '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>
                    <span className="warningIcon">⚠️</span>
                    <strong style={{ color: 'red', fontWeight: '500', fontSize: '12px' }}>
                      Warning: Unauthorised Access Prohibited
                    </strong>
                  </span>
                  <MdKeyboardArrowDown
                    size={20}
                    style={{ cursor: 'pointer', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}
                    onClick={toggleExpand}
                  />
                </p>
                {isExpanded && (
                  <>
                    <span className="bottomLine" />
                    <p className="mb-1" style={{ marginTop: '9px', fontSize: '12px' }}>
                      This is a secure platform intended solely for use by authorised
                      users. Unauthorised access, use, or distribution of any part of
                      this platform is strictly prohibited and may result in legal
                      action, including prosecution under applicable laws. All activity
                      on this platform is monitored and logged. By accessing this
                      system, you agree to comply with all relevant confidentiality,
                      data protection, and regulatory requirements. If you are not an
                      authorised user, please disconnect immediately and report any
                      accidental access to the Reg-X support team.
                    </p>

                    <p className="mb-0">
                      <strong style={{ fontWeight: '600', fontSize: '12px', color: '#303030' }}>
                        Reg-X Innovations Ltd – All rights reserved.
                      </strong>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PopUpMessage;
